import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { mergeMap, tap } from "rxjs/operators";
import { NotificationService } from "../services/notification.service";
import { NotificationActions } from "./actions";

@Injectable()
export class NotificationEffects {
  constructor(
    private actions$: Actions,
    private notificationService: NotificationService
  ) {}

  showNotification$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotificationActions.showNotification),
      tap((action) => this.notificationService.show(action.notification)),
      mergeMap((action) =>
        of(NotificationActions.showNotificationSuccess(action))
      )
    );
  });
}
